import { useContext } from 'react';
import { PlantContext } from '../contexts/PlantContext';

function usePlants() {
  const context = useContext(PlantContext);
  if (context === null) {
    throw new Error('usePlants must be used within a PlantProvider');
  }
  return context;
}

export default usePlants;
